var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(-278 -14087)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Rectangle_6_copy_5",
    "data-name": "Rectangle 6 copy 5",
    cx: 33,
    cy: 33,
    r: 33,
    transform: "translate(278 14087)",
    fill: "#fff",
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("text", {
    id: "f",
    transform: "translate(307 14132.522)",
    fill: "#fff",
    fontSize: 29.882,
    fontFamily: "Helvetica",
    letterSpacing: "-0.04em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "f")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/facebook-logo.a7a10fa811a33e83f3d787a660f9a33a.svg";
export { ForwardRef as ReactComponent };